import hotkeys from 'hotkeys-js';
function createShortcutService() {
    const unbindList = [];
    const on = (keys, listener) => {
        const hotkeyListener = (event, handler) => {
            listener(event, { key: handler.key });
        };
        // @ts-ignore: library's package.json is wrongly configured
        hotkeys(keys, hotkeyListener);
        const unbindHotkey = () => {
            // @ts-ignore: library's package.json is wrongly configured
            hotkeys.unbind(keys, hotkeyListener);
        };
        unbindList.push(unbindHotkey);
        return unbindHotkey;
    };
    const unbindAll = () => {
        unbindList.forEach((unbind) => unbind());
    };
    return {
        on,
        unbindAll,
    };
}
const ShortcutService = createShortcutService();
export { ShortcutService, };
//# sourceMappingURL=shortcut-service.js.map